import { Skeleton } from '@/components/ui/skeleton';

/**
 * Read-only stand-in for a team picker, shown to a team-scoped Admin (not an
 * Owner): they only ever see their own team's data, so a picker implying
 * choice is misleading. Same trigger chrome as the pickers it replaces
 * (h-9, rounded-lg, border-ds-border-subtlest, text-ds-text-darker) but a
 * plain non-interactive div -- no hover state, nothing to open.
 */
export function ViewerTeamIndicator({
  teamName,
  isLoading,
}: {
  teamName: string | null;
  isLoading: boolean;
}) {
  if (isLoading) {
    return <Skeleton className="h-9 w-[168px] rounded-lg" />;
  }
  return (
    <div
      className="inline-flex h-9 shrink-0 items-center gap-2 rounded-lg border border-ds-border-subtlest bg-transparent px-4 text-sm font-medium text-ds-text-darker"
      aria-label={
        teamName ? `Viewing team: ${teamName}` : 'No team assigned to your account'
      }
    >
      {teamName ? (
        <span>Team: {teamName}</span>
      ) : (
        <span className="text-ds-text-subtle">No team assigned</span>
      )}
    </div>
  );
}
